/**
 * Runtime theming: write brand CSS variables onto :root, from a saved localStorage
 * preference — no rebuild needed to rebrand.
 */
export function applyBrand(vars) {
  if (!vars) return;
  const root = document.documentElement;
  for (const [k, v] of Object.entries(vars)) {
    root.style.setProperty(k.startsWith('--') ? k : `--${k}`, v);
  }
}

const KEY = 'app:brand';

export function saveBrand(vars) {
  try {
    localStorage.setItem(KEY, JSON.stringify(vars));
  } catch {}
  applyBrand(vars);
}

export function restoreBrand() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (v) applyBrand(v);
  } catch {}
}
